import React, {Component, createRef} from "react";
import styles from "./FJVideoDetails.module.less";
import FJVideo from "./FJVideo";
import FJPureLoading from "../FJPureLoading";
import FJVideoTool from "./FJVideoTool";
import FJKeywordInfoView from "../FJKeywordInfoView";
import FJStockModalFooterView from "../FJStockModalFooterView";
import FJUtil from "../../../../../util/FJUtil";
import FJNetworkStore from "../../../../../store/FJNetworkStore";
import FJCoreConstant from "../../../../../core/constant/FJCoreConstant";
import key from 'keymaster'
import ResizeSensor from "resize-sensor"

class FJVideoDetails extends Component {

  constructor(props) {
    super(props);

    this.state = {
      viewSize: {width: 'initial', height: 500},
      loading: true,
      isLoaded: false,
      isPlaying: false,
      progress: 0,
      duration: 0.0,
      keywords: [],
      volume: 1,
    }
    this.videoRef = createRef();
    this._isPlayingStateBeforeSeek = false;
    this._urlCaches = {};
    this._minHeight = 360;
    this._space = 90;
  }

  componentDidMount() {
    this._initView();
    key('space', 'videoDetail', () => {
      if (this.state.isPlaying) {
        this.setStop();
      } else {
        this.setPlay();
      }
    });

    this.resizeSensor = new ResizeSensor(document.body, this._updateUI);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.id !== this.props.id) {
      this.setStop();

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({loading: true, progress: 0, keywords: []}, () => {
        if (this.props.id) {
          this._initView();
        }
      });
    }
  }

  componentWillUnmount() {
    key.unbind('space', 'videoDetail');
    this.resizeSensor.detach();
  }

  _initView = () => {
    const {id, cache} = this.props;
    let {url, keywords} = cache[id] || {};
    if (url) {
      this.setState({loading: true, url});
    } else {
      this._initUrl();
    }

    if (keywords && keywords.length !== 0) {
      this.setState({keywords});
    } else {
      this._initKeywords();
    }
  };

  _initUrl = () => {
    const {id} = this.props;
    FJNetworkStore.downloadMedia({id, type: FJCoreConstant.VIDEO}).then(url => {
      this.setState({loading: true, url});
      this.props.updateCache({id, url});
    }).catch(() => {
      this.setState({loading: true, url: this.props.url});
    });
  };
  _initKeywords = () => {
    const {id} = this.props;
    FJNetworkStore.getMedia({id, type: FJCoreConstant.VIDEO}).then(data => {
      let keywords = this._fitKeywords(data.keywords);
      this.setState({keywords});
      this.props.updateCache({id, keywords});
    })
  };

  setStop = () => {
    this._clearTimer();
    this.setState({
      isPlaying: false
    }, () => {
      if (this.videoRef && this.videoRef.current) {
        this.videoRef.current.pause();
      }
    })
  }

  setPlay = () => {
    this._clearTimer();
    this.setState({
      isPlaying: true
    }, () => {
      if (this.videoRef && this.videoRef.current) {
        this.videoRef.current.play();
        this._updateProgress();
      }
    })
  }

  _updateProgress = () => {
    this._clearTimer();
    this._timer = setInterval(() => {
      if (!this.videoRef || !this.videoRef.current) {
        this._clearTimer();
      } else {
        let currentTime = this.videoRef.current.currentTime;
        let duration = this.state.duration;
        let progress = currentTime / duration;
        this.setState({
          progress
        })
      }
    }, 40)
  }

  _clearTimer = () => {
    if (this._timer) {
      clearInterval(this._timer);
    }
  }

  _play = (e) => {
    e.target.blur();
    if (!this.state.isPlaying) this.setPlay();
    if (this.state.isPlaying) this.setStop();
  }

  _reset = () => {
    this._clearTimer();
    if (this.videoRef && this.videoRef.current) {
      this.setState({
        isPlaying: false,
        progress: 0,
      });
      this.videoRef.current.currentTime = 0;
    }
  }

  _setCurrentTime = (progress) => {
    this.videoRef.current.currentTime = this.state.duration * progress
  }

  _setVideoVolume = (type, progress) => {
    this.setState({
      volume: progress,
    }, () => {
      this.videoRef.current.volume = progress;
    })
  }

  /**
   * @description 开始触发进度条
   * @param value 10.25
   * @param progress 0.1025
   * @private
   */
  _onBeforeChange = (value, progress) => {
    this._isPlayingStateBeforeSeek = this.state.isPlaying;
    this.setState({
      progress
    }, () => {
      if (this._isPlayingStateBeforeSeek) {
        this.setStop();
      }
      this._setCurrentTime(progress)
    })
  };

  /**
   * @description 触发进度条
   * @param value
   * @param progress
   * @private
   */
  _onChange = (value, progress) => {
    this.setState({
      progress
    }, () => {
      this._setCurrentTime(progress)
    })
  };

  /**
   * @description 触发进度条end
   * @param value
   * @param progress
   * @private
   */
  _onAfterChange = (value, progress) => {
    this.setState({
      progress
    }, () => {
      if (this._isPlayingStateBeforeSeek) {
        this.setPlay();
      }
      this._setCurrentTime(progress)
    })
  };

  /**
   * @description 视频加载完成
   * @private
   */
  _videoLoaded = () => {
    let {duration} = this.videoRef.current;
    this.setState({
      loading: false,
      isLoaded: true,
      duration: duration,
    }, () => {
      this.setPlay();
    });
    this._updateUI();
  }

  _updateUI = () => {
    let bodyHeight = document.body.getBoundingClientRect().height;
    let curWidth = 0;
    let curHeight = bodyHeight - this._space * 2 - 224;
    curHeight = curHeight < this._minHeight ? this._minHeight : curHeight;
    curWidth = curHeight / 9 * 16;

    this.setState({
      viewSize: {
        width: curWidth,
        height: curHeight,
      },
    }, () => {
      this.props.onViewSizeChange(this.state.viewSize.width);
      let keywords = this._fitKeywords(this.state.keywords);
      this.setState({keywords});
    });
  };

  _onEnded = () => {
    this._reset();
  }

  _onError = () => {
    //
  }

  _onSearch = (keyword) => {
    this._onCancelModal();
    this.props.onSearch(keyword);
  };

  _onCancelModal = () => {
    this._clearTimer()
    this.props.onCancel();
  }

  _onSubmitModal = () => {
    const {onCancel, onSubmit, id, isAddToLibrary, thumbnail, title, duration} = this.props;
    this._clearTimer();
    this.setStop();
    onSubmit(id, isAddToLibrary, '', {
      thumbnail,
      duration,
      name: title,
      onCancel: () => {
        setTimeout(() => {
          key.setScope('videoDetail');
        });
      },
      onSubmit: (hide) => {
        if (hide) {
          onCancel();
        } else {
          setTimeout(() => {
            key.setScope('videoDetail');
          });
        }
      }
    });
  }

  _fitKeywords = (keywords) => {
    if (!keywords || keywords.length === 0) {
      return [];
    }

    let maxWidth = this.state.viewSize.width - 150;
    let curWidth = 0;
    let showKeywords = [];
    for (let i = 0; i < keywords.length; i++) {
      curWidth += FJUtil.getTextSize(keywords[i], {
        fontFamily: "Roboto",
        fontSize: 13,
      }).width + 34;
      if (curWidth < maxWidth) {
        showKeywords.push(keywords[i]);
      } else {
        break;
      }
    }
    if (showKeywords.length === 0) {
      showKeywords = keywords.slice(0, 2);
    }

    return showKeywords;
  };

  _onKeywordClick = (value) => {
    const {onCancel} = this.props;
    onCancel();
    this._onSearch(value);
  };

  render() {
    let {
      loading,
      isPlaying,
      disabled,
      progress,
      duration,
      url,
      keywords,
      isLoaded,
      viewSize,
      volume,
    } = this.state;

    let {
      showTipCallback,
      isAddToLibrary,
      title,
    } = this.props;

    let curTime = progress * duration;
    let currentTime = FJUtil.formatTime(curTime);
    let totalTime = FJUtil.formatTime(duration);

    return (
      <div className={styles.item_container}>
        <div className={styles.video_box}
             style={{
               width: viewSize.width,
               height: viewSize.height,
             }}
        >
          {
            url && <FJVideo videoRef={this.videoRef}
                            onLoadedData={this._videoLoaded}
                            onEnded={this._onEnded}
                            url={url}
            />
          }
          <p className={styles.title}>{title}</p>
          <FJVideoTool isPlaying={isPlaying}
                       play={this._play}
                       onBeforeChange={this._onBeforeChange}
                       onChange={this._onChange}
                       onAfterChange={this._onAfterChange}
                       disabled={disabled}
                       progress={progress}
                       currentTime={currentTime}
                       totalTime={totalTime}
                       setVideoVolume={this._setVideoVolume}
                       isLoaded={isLoaded}
                       volume={volume}
          />
          <FJPureLoading active={loading}/>
        </div>
        {
          keywords.length > 0 && (
            <FJKeywordInfoView keywordClick={this._onKeywordClick}
                               active={isLoaded}
                               hotWords={keywords}
            />
          )
        }
        <FJStockModalFooterView showTipCallback={showTipCallback}
                                onCancel={this._onCancelModal}
                                onSubmit={this._onSubmitModal}
                                isAddToLibrary={isAddToLibrary}
        />
      </div>
    )
  }
}

export default FJVideoDetails;